/** Drop keys whose value is `undefined` (keeps payloads tidy / wire-stable). */
export function compact<T extends object>(obj: T): T {
  const out = {} as Record<string, unknown>
  for (const [k, v] of Object.entries(obj)) {
    if (v !== undefined) out[k] = v
  }
  return out as T
}
